module.exports = __webpack_public_path__ + "img/picture_15.fe1cfc87.png";